<template>
  <v-row>
    <!-- kitchen sink -->
    <v-col cols="12">
      <app-card-code
        :title="`${$t('menu.logs')} / ${$t('menu.users')}`"
      >
        <Logs></Logs>
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

import Logs from './form/Logs.vue'

export default {
  components: {
    AppCardCode,
    Logs,
  },
}
</script>
